/** Build initial checkbox maps from prescription field definitions (Digital PAF step). */
export function buildPrescriberCheckboxInitial(prescriptionField) {
  return (
    prescriptionField?.prescriber_confirmations?.reduce((acc, item) => {
      acc[`checkbox-prescriber-${item.id}`] = false;
      return acc;
    }, {}) ?? {}
  );
}

export function buildRiskCheckboxInitial(prescriptionField) {
  return (
    prescriptionField?.prescription_confirmation_risks?.reduce((acc, item) => {
      acc[`risk-checkbox-${item.id}`] = false;
      return acc;
    }, {}) ?? {}
  );
}
